import { createPortal } from 'react-dom';

import './styles.scss';
import { CloseIcon } from 'assets/icons/CloseIcon';
import { useRef } from 'react';
import { useClickOutside } from 'common/hooks';
import Flipbook from '../Flipbook';

const ImageContent = ({ item }) => {
  const { thumb, content } = item;
  return (
    <>
      <img src={thumb} alt={content} />
      <p>{content}</p>
    </>
  );
};

const VideoContent = ({ item }) => {
  // const { video } = item;
  return (
    <iframe
      width="800"
      height="800"
      src="https://www.youtube.com/embed/OP_fVIUTr9Y"
      title="Architectural animation for the office building in Australia|3D Visualization for Fenders Katsalidis"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      referrerpolicy="strict-origin-when-cross-origin"
      allowfullscreen
    />
  );
};

const DocumentContent = ({ item, onClose }) => {
  if (item.configs) {
    return (
      <Flipbook isOpen={true} onClose={onClose} bookConfig={item.configs} />
    );
  }

  // Fallback for PDF files
  if (item.pdf) {
    return (
      <iframe
        src={item.pdf}
        title={item.title}
        width="100%"
        height="100%"
        frameBorder="0"
        allow="fullscreen"
      />
    );
  }

  return null;
};

const adapter = {
  'hinh-anh': ImageContent,
  video: VideoContent,
  'tai-lieu': DocumentContent,
  'phap-ly': DocumentContent,
};

export const ItemModal = ({ open, onClose, item }) => {
  const closeRef = useRef(null);

  const modalRef = useClickOutside(() => {
    onClose();
  }, [closeRef]);

  if (!open) return null;
  const ContentComponent = adapter[item.type];

  if (!ContentComponent) return null;

  return createPortal(
    <div className={`thu-vien-item-modal ${item.type}`}>
      <div className="modal-backdrop" />
      <button className="close-btn" onClick={onClose} ref={closeRef}>
        <CloseIcon color="#fff" />
      </button>
      <div className={`modal-content `} ref={modalRef}>
        <div className="main-content">
          <ContentComponent item={item} onClose={onClose} />
        </div>
      </div>
    </div>,
    document.body
  );
};
